(function ($) {
  'use strict';
  var fetchPosts = require('./fetchPosts');

  $(document.body).on('change', '#select-category', function () {
    $(this).closest('form').submit();
  });

  $(document.body).on('submit', '#search-archive', function (ev) {
    ev.preventDefault();
    var $this = $(this);
    var fromData = formatDataObj($this.serializeArray());
    fromData['action'] = 'filter_archives';

    fetchPosts(fromData, succes_loaded);
  });

  function succes_loaded(data) {
    var response = JSON.parse(data);
    if(response.have_posts){
      $('.overview-items').html(response.html);
      $('.navigation.pagination').remove();
    }else {
      $('.overview-items').html('<h2>Geen resultaten gevonden.</h2><p>Deze zoekopdracht leverde niets op. Probeer een andere zoekterm of categorie.</p>');
    }
    $('#loading').fadeOut(1000);
    setTimeout(function(){
      $('#loading').remove();
    }, 1000);
  }

  /**
   * [formatDataObj description]
   * @param  {array} data [description]
   * @return {object}      [description]
   */
  function formatDataObj(data) {
    var new_data = {};

    data.map(function (item) {
      new_data[item.name] = item.value;
    });

    return new_data;
  }

}(jQuery));
